import React, {useState, useEffect} from 'react';
import "css/r-footer.css";

const Footer = () =>{
	const [show, setShow] = useState(true)
	const name = "Copyright © 2020 The Hong Kong Polytechnic University. All Rights Reserved.";

	const updateDimensions  = () => {
		if(window.innerWidth < 1000)
			setShow(false);
		else
			setShow(true);
	}

	useEffect(() => {
		window.addEventListener('resize', updateDimensions);
		return() =>{window.removeEventListener('resize', updateDimensions)};
	},[]);

	return (
		<footer className={"footer py-3 b fade-in navbar-fixed-bottom " + (show? " footer-fixed" : "" ) + " bg-custom-green"}>
			<div className="container">
				<p style={{fontSize: 'medium'}} className="m-0 text-center text-white">{name}</p>
			</div>
		</footer>
	)

}
export default Footer;
